import {GameLibraryUserComponent} from "./pages/game-library-user.component";
import {GameLibararyUserViewgameComponent} from "./pages/game-libarary-user-viewgame.component";


export const userLibraryRoutes = [
  {path: '', component: GameLibraryUserComponent, pathMatch: 'full'},
  {path: 'game/:gameId', component: GameLibararyUserViewgameComponent, pathMatch: 'full'},
]
